import { IFormValues } from './types';

export const defaultValues: IFormValues = {
    taskDate: '',
    taskDescription: '',
    taskTitle: '',
};
